<script setup>
import bgSmile from '@/assets/img/bg-smilepicture.png'

import iconBrief from '@/assets/img/icons/icon-brief.png'
import iconConcept from '@/assets/img/icons/icon-conpect.png'
import iconPreProduction from '@/assets/img/icons/icon-pre-production.png'
import iconProduction from '@/assets/img/icons/icon-production.png'
import iconPostProduction from '@/assets/img/icons/icon-post-production.png'

const steps = [
    {
        title: 'Concept',
        desc: 'Every company has a unique story. We develop creative concepts that highlight your brand identity, company values, and the message you want to share with the world.',
        icon: iconConcept,
    },
    {
        title: 'Brief',
        desc: 'We work closely with your team to understand your company, business goals, and target audience, ensuring the video communicates your brand message clearly and effectively.',
        icon: iconBrief,
    },
    {
        title: 'Pre-Production',
        desc: 'In this stage, we plan every detail of the production, including scriptwriting, storyboards, location planning, and production schedules to ensure everything runs smoothly.',
        icon: iconPreProduction,
    },
    {
        title: 'Production',
        desc: 'Our professional production team captures high-quality footage of your company, workplace, and activities to visually represent your brand in an authentic and engaging way.',
        icon: iconProduction,
    },
    {
        title: 'Post Production',
        desc: 'We craft the final story through professional editing, color grading, sound design, and motion graphics, creating a polished company profile video ready to inspire and impress your audience.',
        icon: iconPostProduction,
    },
]
</script>

<template>
    <section class="wrapper" :style="{
        backgroundImage: `url(${bgSmile})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    }">
        <div class="container py-14 py-md-16">
            <h1 class="display-1 mb-3 text-white text-center">
                Our <span class="text-secondary">Service</span>
            </h1>

            <p class="lead text-white text-center mb-10">
                We create impactful company profile videos that showcase your brand story, values, and vision. Through a strategic and creative production process, we transform your company’s identity into a compelling visual experience that connects with your audience.
            </p>

            <div class="row gx-lg-8 gx-xl-12 gy-6 justify-content-start">
                <div class="col-md-6 col-lg-4 step text-center text-md-start" v-for="(step, i) in steps" :key="i">
                    <span class="icon btn btn-circle btn-lg btn-soft-primary disabled mb-4">
                        <img :src="step.icon" alt="" width="40" height="40" />
                    </span>

                    <h4 class="text-white mb-2">{{ step.title }}</h4>
                    <p class="text-white mb-0">{{ step.desc }}</p>

                    <i class="uil uil-arrow-right step-arrow" v-if="i !== 2 && i !== steps.length - 1" />
                </div>
            </div>
        </div>
    </section>
</template>

<style>
.wrapper {
    position: relative;
}

.btn-soft-primary,
.btn-primary {
    background-color: #ff2eb2 !important;
    border-color: #ff2eb2 !important;
}

.wrapper::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 0;
}

.wrapper>.container {
    position: relative;
    z-index: 1;
}

.process-wrapper.line [class*="col-"]:after {
    border-top-color: transparent;
}

/* Icon step panah */
.step {
    position: relative;
}

.step-arrow {
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 2rem;
    color: #ffae0b;
}

.step:last-child .step-arrow {
    display: none;
}

/* ===============================
   HOW WE WORKS RESPONSIVE ARROW
   =============================== */
@media (max-width: 991.98px) {
    .step-arrow {
        display: none;
    }
}
</style>
